export default "__VITE_ASSET__df291669__"